import { unsafeCSS, html } from "lit";
import { BaseValuePropHeading } from "../../base/value-prop-heading/value-prop-heading.js";
const styles = "/*------------------------------------*\\\n    #RESET\n\\*------------------------------------*/\n/**\n * Border-Box http:/paulirish.com/2012/box-sizing-border-box-ftw/\n */\n*,\n::slotted(*),\n*:before,\n*:after {\n  box-sizing: border-box;\n}\n\n:host *,\n:host *::before,\n:host *::after {\n  box-sizing: inherit;\n}\n\n[hidden] {\n  display: none !important;\n}\n\n:host {\n  --leafdcws-value-prop-heading-icon-height: 48px;\n  --leafdcws-value-prop-heading-icon-width: 65px;\n}\n\n.chc-c-value-prop-heading .base-c-value-prop-heading {\n  max-width: 740px;\n}";
const _CHCValuePropHeading = class _CHCValuePropHeading extends BaseValuePropHeading {
  render() {
    return html`<div class="chc-c-value-prop-heading">${super.render()}</div>`;
  }
};
_CHCValuePropHeading.styles = unsafeCSS([BaseValuePropHeading.styles, styles]);
let CHCValuePropHeading = _CHCValuePropHeading;
export {
  CHCValuePropHeading
};
//# sourceMappingURL=value-prop-heading.component.js.map
